import React from "react";
import "./FileEntryCard.css";
import { FiTrash2, FiExternalLink } from "react-icons/fi";
import { BASE_API_URL } from "../services/api";
import { canDelete } from "../utils/permissions";
import { safeUrl } from "../utils/safeUrl";

import {
  FaFilePdf,
  FaFileWord,
  FaFileImage,
  FaFileAlt,
  FaFileArchive,
  FaFile,
} from "react-icons/fa";

const getFileIcon = (fileName) => {
  const ext = fileName.split(".").pop().toLowerCase();

  if (["pdf"].includes(ext)) return <FaFilePdf color="#ef5350" />;
  if (["doc", "docx"].includes(ext)) return <FaFileWord color="#42a5f5" />;
  if (["png", "jpg", "jpeg", "gif", "bmp"].includes(ext)) return <FaFileImage color="#8B8C38" />;
  if (["txt", "md"].includes(ext)) return <FaFileAlt color="#e0e0e0" />;
  if (["zip", "rar"].includes(ext)) return <FaFileArchive color="#ffa726" />;

  return <FaFile color="#9e9e9e" />;
};

function FileEntryCard({
  file,
  onDelete,
  viewMode = "grid",
  selected = false,
  onToggleSelect = null,
  user = null,
}) {
  const isExternalLink =
    file.url?.startsWith("http://") || file.url?.startsWith("https://");

  return (
    <div
      className={`file-card ${viewMode === "list" ? "file-card-list" : ""} ${selected ? "selected" : ""} ${isExternalLink ? "link-card" : ""}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={`file-header ${viewMode}`}>
        <div className="file-meta">
          {onToggleSelect && (
            <input
              type="checkbox"
              className="file-checkbox"
              checked={selected}
              onChange={(e) => {
                e.stopPropagation();
                onToggleSelect();
              }}
            />
          )}

          <span className="file-title-wrapper">
            {getFileIcon(file.name)}
            <span className="file-title-text" title={file.name}>
              {file.name}
            </span>
            {isExternalLink && <span className="link-badge">LINK</span>}
          </span>
        </div>

        <div className="file-actions-row">
          <a
            href={
              isExternalLink
                ? (safeUrl(file.url) || undefined)
                : `${BASE_API_URL}/folders/files/download?url=${encodeURIComponent(file.url)}`
            }
            target="_blank"
            rel="noopener noreferrer"
            className="file-link"
          >
            <FiExternalLink />
            <span>Open</span>
          </a>

          {onDelete && canDelete(file, user) && (
            <button className="file-link danger" onClick={() => onDelete(file)} title="Delete file">
              <FiTrash2 />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default FileEntryCard;
